<template>
  <div>
    <div class="side-frame-success">
      <span style="font-size: 14px; color: #606266">{{
        $l('INDEX.tab_lable_amz_sku_fty') || '生产厂家'
      }}</span>
      <el-divider direction="vertical" v-if="!disabled"></el-divider>
      <b-button
        size="sm"
        class="ml-2"
        variant="outline-success"
        @click="$emit('openEditFormDialog', { type: 'add' })"
        v-if="!disabled"
      >
        <b-icon-plus></b-icon-plus>
        {{ $l('INDEX.btn_add') || '新增' }}
      </b-button>
    </div>
  </div>
</template>
<script>
const initForm = {
  keyword: '',
}

export default {
  props: {
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
